import React from "react";
import styles from "../styles/LegalPage.module.css";

const TermsOfService = () => (
  <div className={styles.legalWrapper}>
    <h1>Terms of Service</h1>
    <p>By using Vionex Labs, you agree to these terms. Please read them carefully.</p>
    <h2>Use of Service</h2>
    <ul>
      <li>Use our website and services lawfully and respectfully</li>
      <li>No unauthorized access or misuse</li>
    </ul>
    <h2>Intellectual Property</h2>
    <ul>
      <li>All content is owned by Vionex Labs unless otherwise stated</li>
    </ul>
    <h2>Limitation of Liability</h2>
    <ul>
      <li>We are not liable for damages from use of our site/services</li>
    </ul>
    <p>Contact us at support@vionexlabs.com for questions about these terms.</p>
  </div>
);

export default TermsOfService;
